
export class FilterBuildingSections {
  static readonly type = '[BuildingSection] Load filtered buildingSections';

  constructor(public buildingId?: string) {
  }
}
